/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
// dependancys
import React, { useState, useEffect, useGlobal } from "reactn";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

// components
import GlobalError from "shared-anpost-components/components/globalError/GlobalError";
import SideNav from "shared-anpost-components/components/SideNav/SideNav";
import DetectDeviceResize from "shared-anpost-components/hooks/detectDeviceResizeHook";

import Header from "../../_core/Header/Header";
import Error from "../../_common/error/Error";
import Transactions from "../_transactions/Transactions";
import Addresses from "../_addresses/Addresses";
import Profile from "../_profile/Profile";
import Overview from "../_overview/Overview";
import MobileTopBar from "../../_core/MobileTopBar/MobileTopBar";

// containers
import AccountContainerStyled from "../../_common/containers/AccountContainer/AccountContainer.styled";
import LeftContainerStyled from "../../_common/containers/LeftContainer/LeftContainer.styled";
import RightContainerStyled from "../../_common/containers/RightContainer/RightContainer.styled";
import { ContentContainerStyled } from "../../_common/contentContainer/ContentContainer.styled";

// hooks
import profileHooks from "../../../hooks/profileHooks";
import LoginFlow from "../_loginFlow/LoginFlow";
import AppHook from "../../../hooks/appHook";
import { hasApplicationCode, getCookie } from "../../../helpers/Helpers";

// api
import { getJWTInfo, getProfile, registerMyDeliveriesUser } from "../../../services/Api";

const HomePage = ({ history, openTab, profileTab }) => {
    const { setActiveTab, values } = profileHooks();
    const { removeNavMargins, handleMainMargin } = AppHook();

    // states
    const [apiError, setApiError] = useState(false);
    const [loader, setLoader] = useState(false);
    const [homepageActiveTab, setHomepageActiveTab] = useState(null);
    const [userProfile, setProfile] = useGlobal("userProfile");
    const [businessname, setBusinessname] = useGlobal("businessName");
    const [isBusiness, setIsBusiness] = useGlobal("isBusiness");
    const [firstname, setFirstname] = useGlobal("firstName");
    const [lastname, setLastname] = useGlobal("lastName");
    const [userEmail, setUserEmail] = useGlobal("email");
    const [isCollapsed] = useGlobal("isCollapsed");
    const [showMobileBanner, setShowMobileBanner] = useGlobal("mobileBanner");
    const [sideNavIndex, setSideNavIndex] = useGlobal("sideNavIndex");
    const [isCustomerRegistered, setIsCustomerRegistered] = useGlobal("mydelsRegistered");
    const [isAnPostApp] = useGlobal("isAnPostApp");

    // hooks
    const { isMobile } = DetectDeviceResize();

    // close error banner
    const closeFunc = () => {
        setApiError(false);
    };

    // check if user is registered for my deliveries. If not, register them
    const myDeliveriesRegCheck = async () => {
        const API_URL = `${window.appMyAccMyDeliveriesAPI}/`;
        const { uid, applications } = JSON.parse(sessionStorage.getItem("userProfile"));

        if (!hasApplicationCode(applications, "anpost_mydeliveries")) {
            const userData = {
                customerName: uid
            };

            try {
                getJWTInfo().then(() => {
                    registerMyDeliveriesUser(uid, userData).then(response => {
                        if (response && response.status === 201) {
                            setIsCustomerRegistered(true);

                            getProfile(uid).then(res => {
                                if (res.status === 200) {
                                    sessionStorage.setItem("userProfile", JSON.stringify(res.data));
                                }
                            });
                        }
                    });
                });
            } catch (err) {
                console.error(err);
            }
        } else {
            setIsCustomerRegistered(true);
        }
    };

    // check if user has business account and set url to /business if not already set
    const checkForBusinessAcc = businessNameInfo => {
        if (businessNameInfo && window.location.pathname.endsWith("/myAccount") && !window.location.pathname.includes("Business")) {
            !isBusiness && setIsBusiness(true);
            if (!getCookie("switch_profile")) {
                document.cookie = "switch_profile=true";
            }

            history.push("/Business");
        }
    };

    // get data from session storage
    // this function is called on first page load or after login
    const getProfileData = profileResponse => {
        setLoader(true);
        getJWTInfo().then(() => {
            const profileData = JSON.parse(sessionStorage.getItem("userProfile")) || profileResponse;
            setProfile(profileData);
            const { profile, email, applications, phones } = profileData;
            checkForBusinessAcc(profile?.business?.name);
            setBusinessname(profile?.business?.name);
            setFirstname(profile?.firstName);
            setLastname(profile?.lastName);
            setUserEmail(email);
            setLoader(false);

            // fallback to check if applicationCode is empty for older accounts
            const machApplication = applications.filter(item => {
                return item.applicationCode === "anpost_myaccount";
            })[0];

            // if they aren't registered, register them here
            if (!machApplication || machApplication === undefined) {
                window.m59.registerApplication();
            }

            // check if there are any phone numbers, and if so show the mobile banner
            if (phones.length === 0 && !showMobileBanner) {
                setShowMobileBanner(true);
            }

            // check for mydels application and if it isn't registered, register it here
            myDeliveriesRegCheck();
        });
    };

    const handleOpenTab = tab => {
        if (tab === "cnp") {
            setSideNavIndex(3);
        }
    };

    const checkTab = () => {
        const tab = openTab || null;

        if (tab) {
            setActiveTab(tab);
            handleOpenTab(tab);
            setHomepageActiveTab(tab);
        }
    };

    // run checks on first load
    useEffect(() => {
        checkTab();

        if (isBusiness && openTab === "overview" && !window.location.pathname.includes("Business")) {
            !isBusiness && setIsBusiness(true);
            history.push("/Business");
        }

        if (openTab === "overview" && !window.location.pathname.includes("Business") && getCookie("switch_profile")) {
            !isBusiness && setIsBusiness(true);
            history.push("/Business");
        }

        if ((window.location.pathname.includes("Business") || getCookie("switch_profile")) && !isBusiness) {
            setIsBusiness(true);
        }
    }, []);

    // set datalayer dashboard type
    useEffect(() => {
        window.dataLayer.push({
            dashboardType: isBusiness ? "Business" : "Personal"
        });
    }, [isBusiness]);

    // change page title in webview navigaton depending on selected tab
    useEffect(() => {
        const appPageNameParagraph = document.querySelector(".app-header__page-name p");
        if (!appPageNameParagraph || !isAnPostApp) return;
        let pageTitle = "My account";

        if (openTab === "addresses") {
            pageTitle = "Address book";
        } else if (openTab === "cnp") {
            pageTitle = "Transactions";
        } else if (openTab === "profile" && profileTab === "marketing") {
            pageTitle = "Marketing preferences";
        } else if (openTab === "profile") {
            pageTitle = "Profile details";
        }

        appPageNameParagraph.innerHTML = pageTitle;
    }, []);

    useEffect(() => {
        if (isMobile) {
            removeNavMargins();
        } else {
            handleMainMargin(isCollapsed);
        }
    }, [isMobile, isCollapsed]);

    return (
        <>
            <div>
                <LoginFlow loginCompleteCallback={getProfileData} />
                {apiError && <GlobalError closeFunc={closeFunc} />}
                <AccountContainerStyled>
                    {isMobile && !isAnPostApp && <MobileTopBar isOverview={(openTab || homepageActiveTab) === "overview"} history={history} />}
                    {!isMobile && (
                        <LeftContainerStyled className={isCollapsed ? "collapsed" : ""}>
                            <SideNav business={isBusiness} isOverview={(openTab || homepageActiveTab) === "overview"} />
                        </LeftContainerStyled>
                    )}
                    <RightContainerStyled>
                        {values.loggedIn && <Header businessName={businessname} firstName={firstname} values={values} email={userEmail} isMobile={isMobile} history={history} />}
                        {!values.loggedIn && window.apDevMode && <Error errorHeading="You are not logged in. You need to be logged into your An Post account to view this page." loginPrompt></Error>}
                        {values.loggedIn && (
                            <ContentContainerStyled>
                                {homepageActiveTab === "overview" && <Overview history={history} userProfile={userProfile} openTab={openTab} />}
                                {homepageActiveTab === "profile" && <Profile userProfile={userProfile} profileTab={profileTab} />}
                                {homepageActiveTab === "addresses" && <Addresses />}
                                {homepageActiveTab === "cnp" && <Transactions />}
                            </ContentContainerStyled>
                        )}
                    </RightContainerStyled>
                </AccountContainerStyled>
            </div>
        </>
    );
};

export default HomePage;
HomePage.propTypes = {
    history: PropTypes.object,
    openTab: PropTypes.string,
    profileTab: PropTypes.string
};
